import { Component, afterNextRender, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MotionService } from './motion/motion.service';
import { AnalyticsService } from './services/analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'drivOn';
  showFooter = true;
  private readonly motion = inject(MotionService);
  private readonly analytics = inject(AnalyticsService);

  constructor(private router: Router, private translate: TranslateService) {
    this.translate.setDefaultLang('en');
    this.analytics.init();
    afterNextRender(() => this.motion.init());

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url === '/error' || event.url === '/coming-soon') {
          this.showFooter = false;
        } else {
          this.showFooter = true;
        }
      }
    });
  }

  localesList = [
    {
      code: 'en-US',
      label: 'English',
    },
    {
      code: 'ru',
      label: 'Russian',
    },
  ];
}
